// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--80bba";
export var arrows = "styles-module--arrows--5f276";
export var card = "styles-module--card--cf911";
export var cardBody = "styles-module--cardBody--16933";
export var cards = "styles-module--cards--8abc8";
export var container = "styles-module--container--f2858";
export var disabled = "styles-module--disabled--49a7c";
export var header = "styles-module--header--bc16a";
export var image = "styles-module--image--f4362";
export var section = "styles-module--section--6ecc1";
export var title = "styles-module--title--90b55";